// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3auaR","resendInfoText":"OnGoingPaymentBox_resendInfoText__33orz"};